import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, RequestConsultaPrimeiraHabilitacao } from './types';

// ACTIONS
import {
	consultaPrimeiraHabilitacaoSuccess,
	consultaPrimeiraHabilitacaoFailure,
} from './actions';

function* consultaPrimeiraHabilitacao(request: ReducerAction) {
	const { payload }: { payload: RequestConsultaPrimeiraHabilitacao } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`eportal/${CHANNEL}/pesquisa/primeira-habilitacao`,
		payload,
	);

	if (response.status === 200 || response.status === 204) {
		yield put(
			consultaPrimeiraHabilitacaoSuccess({ response, request: payload }),
		);
	} else {
		yield put(
			consultaPrimeiraHabilitacaoFailure({
				response: response.data,
				request: payload,
			}),
		);
	}
}

export default all([
	takeLatest(
		Types.CONSULTA_PRIMEIRA_HABILITACAO_REQUEST,
		consultaPrimeiraHabilitacao,
	),
]);
